import App from 'app/app.js';

const DEFAULT_SORT_NUMBER = 9999;

function isUnranked(addon) {
  return addon.sortNumber >= DEFAULT_SORT_NUMBER;
}

function compareBySortNumberThenName(a, b) {
  if (a.sortNumber !== b.sortNumber) {
    return a.sortNumber - b.sortNumber;
  }
  const aName = a.nameDesc || '';
  const bName = b.nameDesc || '';
  return aName.localeCompare(bName, undefined, { numeric: true, sensitivity: 'base' });
}

// Simple implementation for dispatcher poc using $rootScope
function AddOnService(
  OrderLineFactory,
  ShoppingCartStore,
  AnalyticsService,
  BlockService,
  ProductCatalogStore,
  MessageStore,
  ContentStore,
  AddToCartGrowlerService
) {
  this.addOnAddToCart = function (item, look) {
    const skuCode = item.skuCode;

    const orderLineItem = item?.freeGift
      ? item
      : ProductCatalogStore.getProductCatalog().addOns.find((addOn) => addOn.skuCode === skuCode);

    const orderLine = OrderLineFactory.createFromAddOn(orderLineItem, look);

    AnalyticsService.setActiveSku(skuCode);
    AnalyticsService.recordEvent(AnalyticsService.events.CART_ADD);
    AnalyticsService.recordEvent(AnalyticsService.events.UPSELL_CART_ADDED);

    BlockService.blockUI();

    return ShoppingCartStore.addAddOn(orderLine).finally(() => this.confirmAdded(orderLine));
  };
  this.confirmAdded = function (orderLine) {
    BlockService.unblockUI();
    AddToCartGrowlerService.showForStudents(
      [ShoppingCartStore.getCurrentSubject().subjectFirstName],
      [orderLine.orderable.nameDesc]
    );
  };

  this.hasDiscount = (addon) => {
    const currentSubject = ShoppingCartStore.getCurrentSubject();
    return (
      currentSubject?.packages.length &&
      addon?.discountedPriceWithPackage &&
      addon?.unitPrice > addon?.discountedPriceWithPackage
    );
  };

  // Unranked add-ons (sortNumber 9999) go last, in catalog order.
  this.sortAddOns = function (items) {
    const ranked = items.filter((item) => !isUnranked(item));
    const unranked = items.filter(isUnranked);
    return [...ranked.sort(compareBySortNumberThenName), ...unranked];
  };
}
App.service('AddOnService', [
  'OrderLineFactory',
  'ShoppingCartStore',
  'AnalyticsService',
  'BlockService',
  'ProductCatalogStore',
  'MessageStore',
  'ContentStore',
  'AddToCartGrowlerService',
  AddOnService
]);
